// Generated by openapi-codegen. Do not edit manually.

import * as z from 'zod';

export const v1TrackingDataSchema = z.object({
  data: z.array(z.array(z.coerce.string())).describe("Array of tracking data points. Each entry is a 4-element array: [timestamp, app, window, detail]"),
});
